const totp = {

	init: function() {

		document.getElementById('buttonDisable')?.addEventListener('click', function() {
			document.querySelector('input[name=action]').value = 'disable';
		});

		document.getElementById('buttonRegenerate')?.addEventListener('click', function() {
			document.querySelector('input[name=action]').value = 'regenerate';
		});

	},

};

export default totp;
